import http from "@/settings/apiSettings";

class SAL_CalculDataService {
  /** Calcul salarii pentru luna/an. salveaza=false → doar preview, fără a suprascrie SAL_CalculeSalarii. */
  calculeaza(luna: number, anul: number, salveaza = false): Promise<any> {
    return http.clientResurseUmane.post("/Salarizare/Calculeaza", null, {
      params: { luna, anul, salveaza },
    });
  }
}

export default new SAL_CalculDataService();
